module.exports = ":host {\n  display: block;\n  z-index: 1100;\n  position: fixed;\n  left: 30%;\n  right: 30%;\n  top: 35%; }\n  @media (max-width: 767px) {\n    :host {\n      left: 15px;\n      right: 15px;\n      top: 70px; } }\n  @media (min-width: 768px) and (max-width: 991px) {\n    :host {\n      left: 22%;\n      right: 22%;\n      top: 23%; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/alert/alert-container/alert-container.component.scss
// module id = ./src/app/common/alert/alert-container/alert-container.component.scss
// module chunks = main